import * as S from './CaptivateAllImageModalLoader.styles';
import CaptivateAllImageLeftLoader from './CaptivateAllImageLeftLoader';
import CaptivateAllImageRightLoader from './CaptivateAllImageRightLoader';

const CaptivateAllImageLoader = () => (
  <S.CaptivateAllImageModalContainer>
    <S.CaptivateAllImageModalInnerWrap>
      <CaptivateAllImageLeftLoader loaderStyles={{width: '70%'}} />
      <CaptivateAllImageRightLoader />
    </S.CaptivateAllImageModalInnerWrap>
  </S.CaptivateAllImageModalContainer>
);

export default CaptivateAllImageLoader;
